import React, { type ReactNode, createContext, useContext } from 'react'

const StartingPersonIdContext = createContext<string | undefined>('')

export const useStartingPersonIdContext = (): string | undefined => useContext(StartingPersonIdContext)

type Props = {
  startingPersonId: string | undefined
  children: ReactNode
}

export default function StartingPersonProvider({ startingPersonId, children }: Props): JSX.Element {
  return <StartingPersonIdContext.Provider value={startingPersonId}>{children}</StartingPersonIdContext.Provider>
}
